import { AfterContentInit, Component, ElementRef, ViewChild, input, output } from '@angular/core';
import { R1BrandingConstants } from '@r1-compass-library/constants/r1-branding.constants';
import { MatIconModule } from '@angular/material/icon';
import { MatButtonModule } from '@angular/material/button';

@Component({
    selector: 'r1-compass-lib-titled-container',
    imports: [MatButtonModule, MatIconModule],
    template: `
        <div id="title" [style.background-color]="titleBarColor()" #titleDiv>
            <h4>{{ title() }}</h4>
            <button
                mat-button
                id="close-button"
                [style.visibility]="showCloseButton() ? 'visible' : 'hidden'"
                (click)="close.emit()"
                type="button">
                <mat-icon>close</mat-icon>
            </button>
        </div>

        <div id="container">
            <ng-content />
        </div>
    `,
    styles: `
        #title {
            color: var(--r1-white);
            padding-left: 12px;
            padding-top: 8px;
            padding-bottom: 6px;

            display: flex;
            justify-content: space-between;
            align-items: center;

            #close-button {
                color: var(--r1-white);
                min-width: unset;
            }

            h4 {
                margin: 0;
                font-weight: lighter;
            }
        }

        #container {
            background-color: var(--r1-white);
            padding: 32px 20px 24px;
        }
    `,
})
export class TitledContainerComponent implements AfterContentInit {
    title = input.required<string>();
    showCloseButton = input<boolean>(false);
    titleBarColor = input<R1BrandingConstants>(R1BrandingConstants.black);

    @ViewChild('titleDiv', { static: true })
    private titleRef?: ElementRef<HTMLDivElement>;
    private titleStyle?: CSSStyleDeclaration;

    close = output<void>();

    ngAfterContentInit() {
        this.titleStyle = this.titleRef?.nativeElement.style;
        this.titleStyle?.setProperty('--background-color', this.titleBarColor().toString());
    }
}
